import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from './components/ui/toaster';

import ParticleField from './components/ParticleField';
import TopNav from './components/TopNav';
import SideNav from './components/SideNav';
import LiveTicker from './components/LiveTicker';
import ProgressBar from './components/ProgressBar';

import Hero from './sections/Hero';
import TheTide from './sections/TheTide';
import TheCoin from './sections/TheCoin';
import TheDescent from './sections/TheDescent';
import TheSchool from './sections/TheSchool';
import TheLaw from './sections/TheLaw';
import TheNumber from './sections/TheNumber';
import TheRitual from './sections/TheRitual';
import Yours from './sections/Yours';

const Home = () => (
  <>
    <ParticleField count={110} />
    <ProgressBar />
    <TopNav />
    <SideNav />
    <main style={{ position: 'relative', zIndex: 2 }}>
      <Hero />
      <TheTide />
      <TheCoin />
      <TheDescent />
      <TheSchool />
      <TheLaw />
      <TheNumber />
      <TheRitual />
      <Yours />
    </main>
    <LiveTicker />
  </>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
